import { render } from "./ImportProductoSugerido.vue?vue&type=template&id=bab1b622"
import script from "./ImportProductoSugerido.vue?vue&type=script&lang=js"
export * from "./ImportProductoSugerido.vue?vue&type=script&lang=js"

import "./ImportProductoSugerido.vue?vue&type=style&index=0&id=bab1b622&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__